import { jsx as _jsx } from "react/jsx-runtime";
import useIconProps from '../utils/use-icon-props';
import useStrokeWidth from '../utils/use-stroke-width';
const Finance = (props) => {
    const iconProps = useIconProps(props);
    const strokeWidth = useStrokeWidth(iconProps.width);
    return (_jsx("svg", Object.assign({}, iconProps, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", fill: "none", children: _jsx("path", { d: "M0.900131 9.49374L14.9001 0.899994L28.9001 9.49374M4.01123 25.9H25.789M11.789 8.71249H18.0113M5.5668 21.2125V13.4M11.789 21.2125V13.4M18.0112 21.2125V13.4M24.2335 21.2125V13.4", stroke: "currentColor", strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) })));
};
export default Finance;
